import { AiSkillsRoute, LazyPage, NewSkillPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function NewSkillRoute() {
  return (
    <AiSkillsRoute>
      <LazyPage>
        <NewSkillPage />
      </LazyPage>
    </AiSkillsRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/agent/skills/new')({
  component: NewSkillRoute,
});
